"use client";

/**
 * AiLabelIcon — the recording-industry standard "AI" mark (rounded square +
 * heavy geometric AI), hand-vectorized as pure paths (no font dependency).
 * The standardized mark is always black-box/white-glyphs — do not theme it.
 * Standalone asset lives at /public/ai-label.svg for use outside the app.
 */

import React from "react";
import { cn } from "@/lib/utils";

export function AiLabelIcon({
  size = 20,
  className,
  title = "AI-Generated — industry track-level label",
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 160 160"
      width={size}
      height={size}
      role="img"
      aria-label={title}
      className={cn("flex-shrink-0", className)}
    >
      <title>{title}</title>
      <rect x="6" y="6" width="148" height="148" rx="30" fill="#000" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M33 118 L57 42 L81 42 L105 118 H85 L80.5 103 H57.5 L53 118 Z M62 87 H76 L69 61 Z"
      />
      <path fill="#fff" d="M115 42 H135 V118 H115 Z" />
    </svg>
  );
}
